import { render, staticRenderFns } from "./multipleEmployee.vue?vue&type=template&id=1620cde5&scoped=true"
import script from "./multipleEmployee.vue?vue&type=script&lang=js"
export * from "./multipleEmployee.vue?vue&type=script&lang=js"
import style0 from "./multipleEmployee.vue?vue&type=style&index=0&id=1620cde5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1620cde5",
  null
  
)

export default component.exports